import values from 'lodash/values';
import includes from 'lodash/includes';

export enum AddressDescription {
  PostOffice = 'PostOffice',
  HotelMotelExtendedStay = 'HotelMotelExtendedStay',
  OtherBusinessCommercialProperty = 'OtherBusinessCommercialProperty',
  MixedUseProperty = 'MixedUseProperty',
  ResidentialProperty = 'ResidentialProperty',
}

/**
 * Check if string value is in enum.
 *
 * @param val
 */
export const isAddressDescription = (val?: string | null): val is AddressDescription => {
  return includes(values(AddressDescription), val);
};

export const AddressDescriptionTitle: Readonly<{ [reason in AddressDescription]: string }> = {
  [AddressDescription.PostOffice]: 'Post office (e.g. USPS or UPS store)',
  [AddressDescription.HotelMotelExtendedStay]: 'Hotel, motel, or extended stay',
  [AddressDescription.OtherBusinessCommercialProperty]:
    'Other business/commercial property (e.g. storefront, warehouse)',
  [AddressDescription.MixedUseProperty]: 'Mixed-use property (both commercial & residential)',
  [AddressDescription.ResidentialProperty]: 'Residential property (e.g. condo, home, apt, mobile home)',
};

export const AddressDescriptions = [
  AddressDescription.PostOffice,
  AddressDescription.HotelMotelExtendedStay,
  AddressDescription.OtherBusinessCommercialProperty,
  AddressDescription.MixedUseProperty,
  AddressDescription.ResidentialProperty,
];

/** Address descriptions indicating that a business address is for residential purpose. */
export const ResidentialBusinessAddressDescriptions = [
  AddressDescription.MixedUseProperty,
  AddressDescription.ResidentialProperty,
];
